<script lang="typescript">
  import { useMachine } from '@xstate/svelte';
  import { createFeedbackMachine } from './machine';
  import type { FeedbackForm, FeedbackEvent } from './machine';
  export let feedbackform : FeedbackForm;
  let key:string|undefined;
  const machine  = createFeedbackMachine(feedbackform);
  const { state, send } = useMachine(machine);
  const checkKey = () => {
    if (key) {
      const event:FeedbackEvent = { type: 'FETCH', key: key };
      send(event);
    }
  };
  const retry = () => send('FETCH');
  const proceed = () => send('PROCEED');
  $: form = $state.context.form.form;
  $: isKeyNeeded = $state.matches('key_needed.key_input');
  $: isFormShown = $state.matches('feedback');
  $: isError = $state.matches('key_needed.fetch_error');
  $: isKeyNotFound = $state.matches('key_needed.key_not_found');
  $: isFetching = $state.matches('key_needed.fetching_form');
</script>

{#if isFetching}
  <p>
  <i class="fas fa-spinner fa-spin"></i>
  Haetaan tapaamisen tietoja palvelimelta...
  </p>
{/if}

{#if isKeyNotFound}
  <p>Antamallasi avaimella ei ikävä kyllä löytynyt tapaamisen tietoja. Voit vielä tarkistaa avaimen ja yrittää uudelleen.</p>
  <p>Mikäli avain on oikein ja tapaamista ei löydy olemme pahoillamme siitä. Voit myöskin siirtyä antamaan palautetta ilman avainta.</p>
    <p>
    <button on:click={retry}>Yritä uudelleen</button>
    </p>
    <p>
    <button on:click={proceed}>Siirry antamaan palaute</button>
    </p>
{/if}

{#if isKeyNeeded}
  <p>
  Syötä ajanvarauksesi avain allaolevaan kenttään niin palautelomakkeelle haetaan tapaamisen tiedot automaattisesti.
  </p>
  <form on:submit|preventDefault={checkKey}>
    <p>
    <label for="key">Ajanvarauksen avain</label>
    <input id="key" name="key" type="text" bind:value={key} >
    </p>
    <p>
    <input type="submit" value="Lähetä avain" >
    </p>
  </form>
  <h2>Avain hukassa?</h2>
  <p>
  Jos olet hukannut ajanvarauksesi avaimen voit antaa palautteen ilman sitäkin.
  Tärkeintä on että muistat tapaamisen päivämäärän, kellonajan sekä ohjaajan
  nimen.
  </p>
    <p>
    <button on:click={proceed}>Siirry antamaan palaute</button>
    </p>
{/if}

{#if isError}
  <div class="panel panel-error">
    <p>Tapaamisen tietojen haku Nemonetin palvelimelta epäonnistui. Yritä hetken kuluttua uudelleen.</p>
    <p>Voit myös siirtyä antamaan palautetta ilman että tapaamisen tiedot ovat ennalta täytetty.<p>
    <p>
    <button on:click={retry}>Yritä hakua uudelleen</button>
    </p>
    <p>
    <button on:click={proceed}>Siirry antamaan palaute</button>
    </p>
  </div>
{/if}

{#if isFormShown}
  {@html form}
  <!--
  -->
{/if}

<style>
  label {
    display: block;
  }
</style>
